// @flow
'use strict';

import * as React from 'react';

import type { ItemProps } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

export default function Nfce({ item } : ItemProps) {
  return (
      <div className="tab-pane active">
        <h3>Dados da NFC-e</h3>
        <RowDetalhes data={ item }>
          <ColumnDetalhes field="numero" width="20%">Número</ColumnDetalhes>
          <ColumnDetalhes field="serie" width="20%">Série</ColumnDetalhes>
          <ColumnDetalhes field="modeloId" type="modelo" width="20%">Modelo</ColumnDetalhes>
          <ColumnDetalhes field="emitidoEm" type="data" width="20%">Data de emissão</ColumnDetalhes>
          <ColumnDetalhes field="valor" type="moeda" width="20%">Valor Total da NFC-e</ColumnDetalhes>
        </RowDetalhes>

        <h3>Emissão</h3>
        <RowDetalhes data={ item.emissao }>
          <ColumnDetalhes field="naturezaOperacao" width="50%">Natureza da Operação</ColumnDetalhes>
          <ColumnDetalhes field="tipoOperacao" width="25%">Tipo de Operação</ColumnDetalhes>
          <ColumnDetalhes field="destinoOperacao" width="25%">Destino da Operação</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao }>
          <ColumnDetalhes field="munFatoGeradorIcms" width="30%">Município F. Ger. ICMS</ColumnDetalhes>
          <ColumnDetalhes field="munFatoGeradorIbsCbs" width="30%">Município F. Ger. IBS/CBS</ColumnDetalhes>
          <ColumnDetalhes field="formatoImpressao" width="20%">Formato DANFE </ColumnDetalhes>
          <ColumnDetalhes field="tipoEmissao" width="20%">Tipo de Emissão</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao }>
          <ColumnDetalhes field="digitoVerificador" width="22%">Dígito Verificador Chave</ColumnDetalhes>
          <ColumnDetalhes field="ambiente" width="18%">Ambiente</ColumnDetalhes>
          <ColumnDetalhes field="finalidade" width="20%">Finalidade</ColumnDetalhes>
          <ColumnDetalhes field="tipoNotaDebito" width="40%">Tipo Nota de Débito</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao }>
          <ColumnDetalhes field="tipoNotaCredito" width="40%">Tipo Nota de Crédito</ColumnDetalhes>
          <ColumnDetalhes field="consumidorFinal" width="20%">Consumidor Final</ColumnDetalhes>
          <ColumnDetalhes field="presencaComprador" width="40%">Presença Comprador</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao }>
          <ColumnDetalhes field="digestValue">Digest Value da NFC-e</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}